import { Button, Card } from "antd";
import { INTERVALS_TEXT } from "../../../constants/constants";
import { PermissionBadgeList } from "../permissionBadge/PermissionBadge";

interface ISubscriptionProps {
  id: number;
  name: string;
  description: string;
  price: number;
  frequency: string;
  active?: boolean;
  selectSubscription: (id: number) => void;
  subscriptionPlanId: number | null;
  permissions: {
    id: number;
    name: string;
  }[];
  userLimit: number;
}

function SubscriptionColumn({
  id,
  name,
  frequency,
  price,
  description,
  permissions,
  selectSubscription,
  subscriptionPlanId,
  userLimit,
}: ISubscriptionProps) {
  const permSlugs = permissions?.map((p) => p.name) || [];

  return (
    <div>
      <Card
        style={{
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          border: subscriptionPlanId === id ? "2px solid #81BC3D" : "1px solid #f0f0f0",
          height: "100%",
        }}
        bodyStyle={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          padding: "20px",
        }}
      >
        <h2 style={{ marginBottom: "4px", fontSize: "20px" }}>{name}</h2>
        <p
          style={{
            color: "#81BC3D",
            fontSize: "26px",
            fontWeight: 700,
            marginBottom: "8px",
          }}
        >
          ${price}
          <span
            style={{
              fontSize: "14px",
              fontWeight: 400,
              color: "#999",
              marginLeft: "4px",
            }}
          >
            / {INTERVALS_TEXT[frequency]}
          </span>
        </p>

        {subscriptionPlanId === id ? (
          <p
            style={{
              marginBottom: "12px",
              color: "#81BC3D",
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            ✓ Plan actual
          </p>
        ) : (
          <Button
            type="primary"
            style={{
              marginBottom: "12px",
              borderRadius: "8px",
              background: "#81BC3D",
              borderColor: "#81BC3D",
            }}
            onClick={() => selectSubscription(id)}
          >
            Quiero suscribirme
          </Button>
        )}

        <p style={{ marginBottom: "12px", color: "#666", fontSize: "13px" }}>
          {description}
        </p>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            marginBottom: "12px",
            padding: "6px 10px",
            background: "#f6f6f6",
            borderRadius: "8px",
          }}
        >
          <span style={{ fontSize: "13px", color: "#555" }}>
            <strong>Usuarios:</strong> hasta {userLimit}
          </span>
        </div>

        <div style={{ flex: 1 }}>
          <p
            style={{
              fontSize: "12px",
              fontWeight: 600,
              color: "#333",
              marginBottom: "8px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Permisos incluidos
          </p>
          <PermissionBadgeList
            permissions={permSlugs}
            grouped={true}
            size="small"
          />
        </div>
      </Card>
    </div>
  );
}

export default SubscriptionColumn;
